import { ArrayField, Datagrid, FunctionField, TextField, useRecordContext } from "react-admin";
import { settings } from "app";
import { DoctorantChangeActionChoices } from "utils/choices";
import DoctoralDateField from "../../Partials/DoctoralDateField";
import { formatDoctoralDate } from "../../Partials/DoctoralDateField";

const actionLabel = action => DoctorantChangeActionChoices.find(c => c.id === action)?.name ?? "—";

const formatDateTime = iso => formatDoctoralDate(iso, true) || "—";

const ChangesSection = () => {
  const record = useRecordContext();
  const changes = record?.changes ?? [];

  if (changes.length === 0) return <em>Няма данни</em>;

  return (
    <ArrayField source="changes">
      <Datagrid bulkActionButtons={false} rowClick={false} sx={settings.style.secondaryDatagrid}>
        <FunctionField
          label="Действие"
          render={c => actionLabel(c.action)}
        />
        <TextField source="orderNumber" label="Номер на заповед" />
        <DoctoralDateField source="orderDate" label="Дата на заповед" />
        <FunctionField
          label="Дата и час"
          render={c => formatDateTime(c.createdOn)}
        />
        <FunctionField
          label="Извършил"
          render={c => c.createdByName || `Потребител №${c.createdByUserId}`}
        />
      </Datagrid>
    </ArrayField>
  );
};

export default ChangesSection;
